/**
 * Runs `worker` over `items` with at most `concurrency` in flight at once, returning results in the
 * same order as `items` regardless of completion order. Exported for unit testing.
 */
export async function mapWithConcurrency<T, R>(
  items: readonly T[],
  concurrency: number,
  worker: (item: T) => Promise<R>
): Promise<R[]> {
  const results: R[] = new Array(items.length);
  let nextIndex = 0;

  async function runNext(): Promise<void> {
    const index = nextIndex++;
    if (index >= items.length) {
      return;
    }
    results[index] = await worker(items[index]);
    return runNext();
  }

  const workerCount = Math.max(1, Math.min(concurrency, items.length));
  await Promise.all(Array.from({ length: workerCount }, runNext));
  return results;
}
